/**
 * Everyone by department — Aaron's note of Oct 23 (step 29): the people
 * button "should show everyone I have access to grouped by department".
 */
import type { ActivityPerson } from '@rowted/shared'

/**
 * Everyone this person may see, by department — role and place, the grouping
 * *Choose several…* uses — the people shown now first within each, then by
 * name; largest department first. One function, so the quick list, the
 * chooser and the phone's sheet group the same way.
 */
export function byDepartment(people: readonly ActivityPerson[], shown: readonly string[]): [string, ActivityPerson[]][] {
  const sections = new Map<string, ActivityPerson[]>()
  for (const person of people) {
    const key = [person.role, person.place].filter(Boolean).join(' · ') || 'People'
    sections.set(key, [...(sections.get(key) ?? []), person])
  }
  const shownAt = (id: string) => { const at = shown.indexOf(id); return at === -1 ? shown.length : at }
  for (const list of sections.values()) list.sort((a, b) => shownAt(a.id) - shownAt(b.id) || a.name.localeCompare(b.name))
  return [...sections.entries()].sort((a, b) => b[1].length - a[1].length || a[0].localeCompare(b[0]))
}

